import { Link } from "react-router-dom";
import { ArrowLeft, Edit, Trash } from "lucide-react";
import { PageHeader } from "@/components/PageHeader";
import { Button } from "@/components/ui/button";
import { useTranslation } from "react-i18next";

interface CandidateDetailHeaderProps {
  isEditModalOpen: boolean;
  setIsEditModalOpen: (isOpen: boolean) => void;
  handleDelete: () => Promise<void>;
}

export const CandidateDetailHeader = ({
  isEditModalOpen,
  setIsEditModalOpen,
  handleDelete
}: CandidateDetailHeaderProps) => {
  const { t } = useTranslation();
  return (
    <>
      <PageHeader 
        title={t("candidates.profile.header")}
        actions={
          <div className="flex gap-2">
            <Button 
              variant="outline" 
              className="flex items-center gap-2"
              onClick={() => setIsEditModalOpen(true)}
            >
              <Edit className="h-4 w-4" />
              <span>{t("candidates.actions.edit")}</span>
            </Button>
            <Button 
              variant="outline" 
              className="flex items-center gap-2 text-red-600 hover:text-red-700"
              onClick={handleDelete}
            >
              <Trash className="h-4 w-4" />
              <span>{t("candidates.actions.delete")}</span>
            </Button>
          </div>
        }
      />
      
      <div className="mb-6">
        <Link to="/candidates" className="text-digger-blue hover:underline flex items-center">
          <ArrowLeft className="h-4 w-4 mr-1" />
          {t("candidates.profile.backToCandidates")}
        </Link>
      </div>
    </>
  );
};
